import create from 'zustand';

export const useStore = create((set) => ({
  data: {},

  setBlockData: (id, dataOrFn) =>
    set(({ data: prevData }) => ({
      data: {
        ...prevData,
        [id]: typeof dataOrFn === 'function' ? dataOrFn(prevData) : dataOrFn,
      },
    })),
  setData: (dataOrFn) =>
    set(({ data: prevData }) => ({
      data: typeof dataOrFn === 'function' ? dataOrFn(prevData) : dataOrFn,
    })),
}));
